import React from 'react';
import { Box, TextField, Button } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { useStyles, CustomPopper } from '../../Pages/FttsLandingPage/useStyles';

const FilterDrawer = ({
  selectedTab,
  regions = [],
  cities = [],
  rings = [],
  sites = [],
  links = [],
  region,
  setRegion,
  city,
  setCity,
  ring,
  setRing,
  site,
  setSite,
  link,
  setLink,
  handleRegionChange,
  handleCityChange,
  handleSiteChange,
  handleLinkChange,
  handleReset,
  handleApply,
}) => {
  const classes = useStyles();

  return (
    <Box
      sx={{
        justifyContent: 'space-between',
        flexDirection: 'row',
        display: 'flex',
      }}
      role="presentation"
    >
      <Box
        sx={{
          gap: 1,
          justifyContent: 'left',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            mt: 1,
            justifyContent: 'space-between',
            marginLeft: '1%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '8px',
            }}
          >
            {selectedTab !== 'mpbn' && (
              <Autocomplete
                disablePortal
                id="region"
                options={(regions || []).filter(Boolean)}
                getOptionLabel={(option) => option || ''}
                classes={classes}
                clearOnEscape={false}
                size="small"
                value={region}
                PopperComponent={CustomPopper}
                sx={{
                  width: 170,
                  color: '#fff',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'transparent',
                    },
                  },
                  '.MuiAutocomplete-input': {
                    color: '#fff',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    fontSize: '12px',
                  },
                  '.MuiAutocomplete-endAdornment': {
                    display: 'none',
                  },
                  '& .MuiInputLabel-root': {
                    color: '#fff',
                    fontSize: '11px',
                  },
                  '& .MuiSvgIcon-root': {
                    color: '#fff',
                  },
                }}
                onChange={(event, newValue) => {
                  if (newValue !== null) {
                    setRegion(newValue);
                    setCity('');
                    setRing('');
                    handleRegionChange && handleRegionChange(newValue);
                  }
                }}
                PopoverProps={{
                  sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Region"
                    sx={{ background: '#3A474F', borderRadius: '5px', width: '100%' }}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: '12px' },
                    }}
                  />
                )}
              />
            )}

            <Autocomplete
              disablePortal
              id="city"
              options={(cities || []).filter(Boolean)}
              getOptionLabel={(option) => option || ''}
              size="small"
              value={city}
              clearOnEscape={false}
              PopperComponent={CustomPopper}
              classes={classes}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setCity(newValue);
                  setRing('');
                  setLink('');
                  setSite('');
                  handleCityChange && handleCityChange(newValue);
                }
              }}
              sx={{
                width: 160,
                color: '#fff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'transparent',
                  },
                  '&:hover fieldset': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'transparent',
                  },
                },
                '.MuiAutocomplete-input': {
                  color: '#fff',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                  fontSize: '12px',
                },
                '.MuiAutocomplete-endAdornment': {
                  display: 'none',
                },
                '& .MuiInputLabel-root': {
                  color: '#fff',
                  fontSize: '11px',
                },
                '& .MuiSvgIcon-root': {
                  color: '#fff',
                },
              }}
              PopoverProps={{
                sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="City"
                  sx={{ background: '#3A474F', borderRadius: '5px' }}
                />
              )}
            />
            {selectedTab === 'ftts' && (
              <Autocomplete
                disablePortal
                id="ring"
                options={(rings || []).filter(Boolean)}
                getOptionLabel={(option) => option || ''}
                PopperComponent={CustomPopper}
                clearOnEscape={false}
                size="small"
                value={ring}
                onChange={(event, newValue) => {
                  if (newValue !== null) {
                    setRing(newValue);
                  }
                }}
                sx={{
                  width: 170,
                  color: '#fff',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'transparent',
                    },
                    '&:hover fieldset': {
                      borderColor: 'transparent',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: 'transparent',
                    },
                  },
                  '.MuiAutocomplete-input': {
                    color: '#fff',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    paddingLeft: '5px',
                    paddingRight: '5px',
                    fontSize: '12px',
                  },
                  '.MuiAutocomplete-endAdornment': {
                    display: 'none',
                  },
                  '& .MuiInputLabel-root': {
                    color: '#fff',
                    fontSize: '11px',
                  },
                  '& .MuiSvgIcon-root': {
                    color: '#fff',
                  },
                }}
                PopoverProps={{
                  sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Ring"
                    sx={{ background: '#3A474F', color: '#fff', borderRadius: '5px' }}
                  />
                )}
              />
            )}
            <Autocomplete
              key={(sites || []).join(',')}
              disablePortal
              id="site"
              options={(sites || []).filter(Boolean)}
              getOptionLabel={(option) => option || ''}
              PopperComponent={CustomPopper}
              clearOnEscape={false}
              size="small"
              value={site}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setSite(newValue);
                  handleSiteChange && handleSiteChange(newValue);
                }
              }}
              sx={{
                width: 130,
                color: '#fff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'transparent',
                  },
                  '&:hover fieldset': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'transparent',
                  },
                },
                '.MuiAutocomplete-input': {
                  color: '#fff',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                  fontSize: '12px',
                },
                '.MuiAutocomplete-endAdornment': {
                  display: 'none',
                },
                '& .MuiInputLabel-root': {
                  color: '#fff',
                  fontSize: '11px',
                },
                '& .MuiSvgIcon-root': {
                  color: '#fff',
                },
              }}
              PopoverProps={{
                sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Site"
                  sx={{ background: '#3A474F', color: '#fff', borderRadius: '5px' }}
                />
              )}
            />
            <Autocomplete
              disablePortal
              id="link"
              options={(links || []).filter(Boolean)}
              getOptionLabel={(option) => option || ''}
              PopperComponent={CustomPopper}
              clearOnEscape={false}
              size="small"
              value={link}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  setLink(newValue);
                  handleLinkChange && handleLinkChange(newValue);
                }
              }}
              sx={{
                width: 170,
                color: '#fff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: 'transparent',
                  },
                  '&:hover fieldset': {
                    borderColor: 'transparent',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'transparent',
                  },
                },
                '.MuiAutocomplete-input': {
                  color: '#fff',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  paddingLeft: '5px',
                  paddingRight: '5px',
                  fontSize: '12px',
                },
                '.MuiAutocomplete-endAdornment': {
                  display: 'none',
                },
                '& .MuiInputLabel-root': {
                  color: '#fff',
                  fontSize: '11px',
                },
                '& .MuiSvgIcon-root': {
                  color: '#fff',
                },
              }}
              PopoverProps={{
                sx: { zIndex: (theme) => theme.zIndex.modal + 1 },
              }}
              renderOption={(props, option) => (
                <li {...props} title={option || ''}>
                  <div
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '150px',
                    }}
                  >
                    {option || ''}
                  </div>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={selectedTab === 'mpbn' ? 'Trunk' : 'Link'}
                  sx={{ background: '#3A474F', color: '#fff', borderRadius: '5px' }}
                />
              )}
            />

            <Button
              variant="contained"
              sx={{
                backgroundColor: '#3A474F',
                fontSize: '11px',
                mr: 1,
                '&:hover': {
                  border: '1px solid #bd1d23',
                  backgroundColor: '#bd1d23',
                  color: 'white',
                  boxShadow: 'inset 0 0 10px #bd1d23',
                  fontSize: '11px',
                },
              }}
              className="table-icon"
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#3A474F',
                fontSize: '11px',
                '&:hover': {
                  border: '1px solid #bd1d23',
                  fontSize: '11px',
                  backgroundColor: '#bd1d23',
                  color: 'white',
                  boxShadow: 'inset 0 0 10px #bd1d23',
                },
              }}
              className="table-icon"
              onClick={() => handleApply && handleApply()}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '6px',
        }}
      ></Box>
    </Box>
  );
};

export default FilterDrawer;
